module.exports = __webpack_public_path__ + "static/img/icon2-5.13e58c35.png";